<template>
  <footer class="border-top py-5">
    <div class="container">
      <div class="row">
        <div class="col-md-6 text-center-xs">
          <p><strong>Card Payments Portal</strong>, Powered by FNB.<br>
           © Chamdor Faktry Sales. All Rights Reserved.
           <br>
           </p>
        </div>  
        <div class="col-md-6 text-right text-center-xs">
          <img src="@/assets/img/cards.png" alt="FNB Logo" class="img-fluid">
        
        </div>       
      </div>
    </div>
  </footer>
</template>

<script>
export default {

}
</script>

<style>

</style>